export default function useSuccessToast(message: string, values?: Record<string, any> | number, life?: number): void {
  const nuxtApp = useNuxtApp()
  const { $toast } = nuxtApp
  const { t } = nuxtApp.$i18n

  // Handle overloaded parameters
  let interpolationValues: Record<string, any> | undefined
  let toastLife: number = 5000

  if (typeof values === 'number') {
    // Old signature: useSuccessToast(message, life)
    toastLife = values
  }
  else {
    // New signature: useSuccessToast(message, values, life)
    interpolationValues = values
    if (life !== undefined) {
      toastLife = life
    }
  }

  $toast.add({
    severity: 'success',
    summary: 'Success',
    detail: t(message, interpolationValues || {}),
    life: toastLife,
  })
}
